import './assets/index.css'
import { createApp, nextTick } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import 'preline/preline'

// Import Froala Editor
import 'froala-editor/js/plugins.pkgd.min.js'
import 'froala-editor/js/third_party/font_awesome.min'
import 'froala-editor/js/third_party/image_tui.min'
import 'froala-editor/js/languages/de.js'
import 'froala-editor/css/froala_editor.pkgd.min.css'
import 'froala-editor/css/froala_style.min.css'
import VueFroala from 'vue-froala-wysiwyg'

import App from './App.vue'
import router from './router'
import posthog from 'posthog-js'
import posthogPlugin from './plugins/posthog'
import setupPdfs from './utils/pdfjs'
import { setupApiV2, setupApiV3, setupSentry, setupTranslations } from '@/utils/bootstrap'
import { useUserStore } from '@/store/userStore'

const app = createApp(App)
const i18n = createI18n({ legacy: false })
const API_URL = import.meta.env.VITE_API_URL
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
const ENV = import.meta.env.VITE_ENV

app.use(createPinia())
app.use(router)

// Set up API clients
setupApiV3({ apiUrl: API_URL })
setupApiV2({ apiUrl: API_URL })

// Set up Sentry error tracking with PostHog integration
setupSentry({
  app,
  router,
  dsn: SENTRY_DSN,
  environment: ENV,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  additionalIntegrations: [
    posthog.sentryIntegration({
      organization: import.meta.env.SENTRY_ORGANIZATION,
      projectId: import.meta.env.SENTRY_PROJECT_ID,
      severityAllowList: ['error', 'info']
    })
  ]
})

// Set up translations
setupTranslations({ app, i18n })
app.use(VueFroala)

const setupPostHog = () => {
  /**
   * Set up PostHog:
   * - Initialize PostHog
   * - Identify the user
   * - Capture page views
   */

  console.log('API_URL', API_URL)
  app.use(posthogPlugin)
  const userStore = useUserStore()
  const { fetchUser } = userStore
  fetchUser().then((user) => {
    if (user) {
      app.config.globalProperties.$posthog.identify(user.uid, {
        id: user.uid,
        uuid: user.uuid,
        oid: user.org.oid,
        ouuid: user.org.uuid
      })
      app.config.globalProperties.$posthog.group('company', user.org.oid, {
        oid: user.org.oid,
        ouuid: user.org.uuid
      })
    }
  })
  router.afterEach((to, from, failure) => {
    if (!failure) {
      nextTick(() => {
        app.config.globalProperties.$posthog.capture('$pageview', { path: to.fullPath })
      })
    }
  })
}
// setupPostHog()

setupPdfs()

app.mount('#app')
